/**
* DevExpress Dashboard (format-condition-base.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { ModelSerializer } from '@devexpress/analytics-core/analytics-utils';
import * as ko from 'knockout';
import { SerializableModel } from '../../serializable-model';
import { formatConditionBaseSerializationsInfo } from './metadata/_format-condition-base';
export class FormatConditionBase extends SerializableModel {
    get _isApplyToRowColumnRestricted() { return false; }
    constructor(modelJson, serializer = new ModelSerializer()) {
        super(modelJson || {}, serializer);
        this.dataType = ko.observable();
        this.dateTimeGroupInterval = ko.observable();
        this._empty = true;
        this.isEmpty = ko.observable();
        this.isEmpty(!modelJson);
    }
    getInfo() {
        return formatConditionBaseSerializationsInfo;
    }
    isValid() {
        return true;
    }
    isRange() {
        return false;
    }
    isGradient() {
        return false;
    }
    init() {
        this.isEmpty(false);
    }
}
